<template>
  <v-list-group :value="false">
    <template v-slot:activator>
      <v-list-item-title>{{ item.name }}</v-list-item-title>
    </template>

    <v-list>
      <v-list-item
        v-for="(child, index) in item.children"
        :key="index"
        dense
        :to="child.type == 'page' ? child.link : null"
        :href="child.type == 'url' ? child.link : null"
        :target="child.type == 'url' ? '_blank' : ''"
        @click="clicked(child)"
      >
        <v-list-item-title>{{ child.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-list-group>
</template>

<script>
import PageMobileMenuButton from './PageMobileMenuButton'
import SectionMobileMenuButton from './SectionMobileMenuButton'
import UrlMobileMenuButton from './UrlMobileMenuButton'

export default {
  name: 'ParentMobileMenuButton',
  props: {
    item: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      required: true
    }
  },
  components: {
    PageMobileMenuButton,
    SectionMobileMenuButton,
    UrlMobileMenuButton
  },
  data: () => ({
    subMenu: false
  }),
  methods: {
    clicked(item) {
      if (item.type == 'section') {
        this.$vuetify.goTo(item.link, {
          offset: this.$store.state.section.stickyHeader.height
        })
      }
    }
  }
}
</script>
